export const checkinModalGlobal = {
  header: {
    phone: "Telefon",
    accommodation: "Obiekt",
    checkin: "Check-in",
    booking: "Rezerwacja",
    notAvailable: "Niedostępne",
    notLinked: "Brak powiązania",
    defaultGuestName: "Gość",
  },
  roles: {
    botStaff: "BOT / OBSŁUGA",
    guest: "GOŚĆ",
  },
  media: {
    imageAlt: "Wysłane zdjęcie",
    locationReceived: "📍 Otrzymano lokalizację",
    openInMaps: "Otwórz w Mapach Google",
    viewCoordinates: "Zobacz współrzędne ({lat}, {lng})",
    viewFile: "Zobacz plik",
    document: "Dokument",
  },
  dropzone: {
    text: "Upuść, aby załączyć pliki",
  },
  failure: {
    notSent: "Nie wysłano",
    notSentDefault: "Nie wysłano",
    reasons: {
      paymentIssue: "problem z płatnością na koncie WhatsApp",
      cannotReceive: "ten numer nie może odbierać wiadomości WhatsApp",
      downloadFailed: "WhatsApp nie mógł pobrać pliku",
      templateMissingData: "w szablonie brakuje danych",
      requirementsNotMet: "wiadomość nie spełnia wymagań WhatsApp",
    },
  },
  mode: {
    ai: "AI",
    manual: "Ręczny",
    autoReplyBanner: "Agent odpowiada temu gościowi automatycznie.",
  },
  predefined: {
    header: "Gotowe odpowiedzi",
    empty: "Nie znaleziono gotowych odpowiedzi",
  },
  input: {
    attachFile: "Załącz plik",
    placeholder: "Zacznij od /, aby wybrać gotową odpowiedź.",
    removeFile: "Usuń plik",
  },
  toasts: {
    noBookingLinkedSummary: "Brak powiązanej rezerwacji",
    noBookingLinkedDetail: "Z tą rozmową nie jest powiązana żadna rezerwacja",
    errorSummary: "Błąd",
    userIdError: "Nie udało się pobrać identyfikatora użytkownika",
    manualModeSummary: "Włączono tryb ręczny",
    aiModeSummary: "Włączono agenta AI",
    manualModeDetail: "Odpowiedzi na wiadomości będą wysyłane ręcznie",
    aiModeDetail: "Bot będzie odpowiadał automatycznie",
    modeChangeError: "Nie udało się zmienić trybu czatu",
    reactivateIdError: "Nie udało się rozpoznać rozmowy do ponownej aktywacji.",
    successSummary: "Gotowe",
    templateSentOk: "Szablon został wysłany.",
    templateSentError: "Nie udało się wysłać szablonu ponownej aktywacji.",
    fileTypeSummary: "Niedozwolony typ pliku",
    fileTypeDetail: "{name} nie jest obrazem ani plikiem PDF.",
    fileSizeSummary: "Plik jest za duży",
    fileSizeDetail: "{name} przekracza limit 5 MB.",
    sendError: "Nie udało się wysłać wiadomości",
  },
};
